import "./style.css";
import { o, t, c, n } from "./variables-D0GyMa6A-BBBECOIn-CLBaPvDW-BZ4dfkiv.js";
var L = ((E) => (E[E.DEFAULT = parseInt(o, 10)] = "DEFAULT", E[E.MEDIUM = parseInt(t, 10)] = "MEDIUM", E[E.LARGE = parseInt(c, 10)] = "LARGE", E[E.XLARGE = parseInt(n, 10)] = "XLARGE", E))(L || {});
export {
  L
};
